import { create } from 'zustand';
import { TextBlockData, TextSimpleData } from '../dto/EntityRepository';

interface ImportStationTextState {
  selectedId: string;
  setSelectedId: (selectedId: string) => void;
  selectedSubIdList: string[];
  addSelectedSubId: (subId: string) => void;
  removeSelectedSubId: (subId: string) => void;
  clearSelectedSubIdList: () => void;
  simpleList: TextSimpleData[];
  simpleSubList: TextBlockData[];
  setSimpleList: (simpleList: TextSimpleData[]) => void;
  setSimpleSubList: (simpleSubList: TextBlockData[]) => void;
  clearSimpleSubList: () => void;
  clearSimpleList: () => void;
}

export const useImportStationTextStore = create<ImportStationTextState>((set) => ({
  selectedId: "",
  setSelectedId: (selectedId: string) => {
    set(() => ({
      selectedId,
    }));
  },
  selectedSubIdList: [],
  addSelectedSubId: (subId: string) => {
    set((state) => ({
      selectedSubIdList: state.selectedSubIdList.includes(subId)
        ? state.selectedSubIdList
        : [...state.selectedSubIdList, subId],
    }));
  },
  removeSelectedSubId: (subId: string) => {
    set((state) => ({
      selectedSubIdList: state.selectedSubIdList.filter((id) => id !== subId),
    }));
  },
  clearSelectedSubIdList: () => {
    set({ selectedSubIdList: [] });
  },
  simpleList: [],
  simpleSubList: [],
  setSimpleList: (simpleList: TextSimpleData[]) => {
    set(() => ({
      selectedId: "",
      selectedSubIdList: [],
      simpleList,
      simpleSubList: [],
    }));
  },
  setSimpleSubList: (simpleSubList: TextBlockData[]) => {
    set(() => ({
      simpleSubList,
    }));
  },
  clearSimpleSubList: () => {
    set(() => ({
      selectedId: "",
      selectedSubIdList: [],
      simpleSubList: [],
    }));
  },
  clearSimpleList: () => {
    set(() => ({
      selectedId: "",
      selectedSubIdList: [],
      simpleList: [],
      simpleSubList: [],
    }));
  },
}));